"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactNumbers = void 0;
const dom_utils_1 = require("../../utils/dom-utils");
class ContactNumbers {
    constructor() {
        this.getNumbers = () => {
            let numbersArray = {};
            const phones = document.querySelectorAll(`[itemprop='phoneNumber']`);
            phones.forEach((phone) => {
                const country = phone.getAttribute('data-country');
                const phoneNumber = phone.getAttribute('content');
                if (country && phoneNumber) {
                    numbersArray[country] = phoneNumber;
                }
            });
            return numbersArray;
        };
        this.setContactNumber = (country) => {
            const number = (0, dom_utils_1.elementId)('formNumber');
            if (number) {
                const numbers = this.getNumbers();
                number.innerHTML = numbers[country] || numbers['Default'];
            }
        };
    }
}
exports.ContactNumbers = ContactNumbers;
